import React from 'react'

import { string, bool, func, node } from 'prop-types'
import Typography from 'components/atoms/Typography'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import classNames from 'classnames'

const FAQ = ({ question, answer, active, onClick }) => (
  <div className={classNames('faq', { active })} onClick={onClick}>
    <Typography component="h3" variant="headline" className="faq__question">
      { question }
    </Typography>
    <CSSTransitionGroup
      transitionName="answer"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      {
        active && (
          <div>
            <div className="faq__answer">
              { answer }
            </div>
          </div>
        )
      }
    </CSSTransitionGroup>
    <style jsx>
      {`
        .faq{
          padding: 0;
          border-radius: 0 !important;
          border: solid 1px #bed2e8;
          margin-bottom: -1px;
          background-color: #fff;
          :global(&__question) {
            padding: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: 500 !important;
            cursor: pointer;
            &::after {
              content: '';
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              border-top: 8px solid #8fb0d4;
              transition: .4s ease-in-out;
            }
          }
          &__answer {
            padding: 24px;
            border-top: solid 1px #bed2e8;
            background-color: #f6f7fa;
            color: #485c77;
          }
          &.active {
            background-color: #fff;
            :global(.faq__question) {
              color: #0fc3c4;
              font-weight: 700 !important;
              &::after {
                transform: rotate(180deg);
              }
            }
            :global(&__answer) {
              color: #485c77;
            }
          }
        }
        .answer-enter {
          max-height: 0px;
          transition: all .5s ease-in-out;
          overflow: hidden;
        }
        .answer-enter-active {
          height: auto;
          max-height: 256px;
        }
        .answer-leave {
          height: auto;
          max-height: 256px;
        }
        .answer-leave-active {
          overflow: hidden;
          max-height: 0px;
          transition: all .5s ease-in-out;
        }
      `}
    </style>
  </div>
)

FAQ.propTypes = {
  question: string,
  answer: node,
  active: bool,
  onClick: func,
}

export default FAQ
